import { IState } from '../../store';
import { IOffersComparisonStatus } from '../../types/offersComparisonStatus';

export const getOffersComparisonStatus = (state: IState): IOffersComparisonStatus | null => {
  return state.offerData.offersComparisonStatus;
};
